var _a;
import { GET_CURRENT_SCENARIO_SECONDS_PER_TICK } from './config';
export default (_a = {},
    _a[GET_CURRENT_SCENARIO_SECONDS_PER_TICK] = function (state) {
        return state.currentScenario.secondsPerTick;
    },
    _a);
